import { ThemeProviderProps } from 'next-themes'
import { ValueOf } from 'next/dist/shared/lib/constants'

export const DarkThemesEnum = {
  DARK: 'dark',
} as const

export const LightThemesEnum = {
  LIGHT: 'light',
} as const

export const ThemesEnum = {
  ...LightThemesEnum,
  ...DarkThemesEnum,
} as const

export const DefaultThemes = {
  ['light']: ThemesEnum.LIGHT,
  ['dark']: ThemesEnum.DARK,
} as const

export const Themes: ThemeProviderProps['themes'] = Object.values(ThemesEnum)

export type ThemeType = {
  name: {
    light: ValueOf<typeof LightThemesEnum>
    dark: ValueOf<typeof DarkThemesEnum>
  }
  label: string
  activeColor: {
    light: string
    dark: string
  }
}

export const ThemesData: ThemeType[] = [
  {
    name: {
      light: ThemesEnum.LIGHT,
      dark: ThemesEnum.DARK,
    },
    label: 'Тема',
    activeColor: {
      light: '221.2 83.2% 53.3%',
      dark: '217.2 91.2% 59.8%',
    },
  },
] as const
